<div class="insta-wrap container">
    <h1>INSTA STUFF</h1>
    <a href="https://api.instagram.com/oauth/authorize/?client_id=240fc475ad0e43d383570dd87398fa43&redirect_uri=http://localhost:4200/auth&response_type=token">INSTA LOGIN</a>
</div>
